import { render, staticRenderFns } from "./cate10.vue?vue&type=template&id=b5675122"
import script from "./cate10.vue?vue&type=script&lang=js"
export * from "./cate10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports